export default {
    data() {
        return {
            links: [
                {
                    name: "dashboard",
                    label: "Dashboard",
                    parent: null,
                    sets: ["main"],
                },
                {
                    name: "checkin.index",
                    label: "Event Checkin",
                    parent: "dashboard",
                    sets: ["main"],
                },
                {
                    name: "events.index",
                    label: "Events",
                    parent: "dashboard",
                    sets: ["admin"],
                },
                {
                    name: "events.show",
                    label: "Update Event",
                    parent: "events.index",
                    sets: [],
                },
                {
                    name: "events.create",
                    label: "Create Event",
                    parent: "events.index",
                    sets: [],
                },
                {
                    name: "venues.index",
                    label: "Venues",
                    parent: "dashboard",
                    sets: ["admin"],
                },
                {
                    name: "venues.show",
                    label: "Update Venue",
                    parent: "venues.index",
                    sets: [],
                },
                {
                    name: "venues.create",
                    label: "Create Venue",
                    parent: "venues.index",
                    sets: [],
                },
                {
                    name: "productions.index",
                    label: "Productions",
                    parent: "dashboard",
                    sets: ["admin"],
                },
                {
                    name: "productions.show",
                    label: "Update Production",
                    parent: "productions.index",
                    sets: [],
                },
                {
                    name: "productions.create",
                    label: "Create Production",
                    parent: "productions.index",
                    sets: [],
                },
                {
                    name: "sections.show",
                    label: "Ticket Section",
                    parent: "venues.show",
                    sets: [],
                },
                {
                    name: "sections.create",
                    label: "Ticket Section",
                    parent: "venues.show",
                    sets: [],
                },
                {
                    name: "types.show",
                    label: "Ticket Type",
                    parent: "sections.show",
                    sets: [],
                },
                {
                    name: "types.create",
                    label: "Ticket Type",
                    parent: "sections.show",
                    sets: [],
                },
                {
                    name: "ticket-price-plans.show",
                    label: "Ticket Price Plans",
                    parent: "venues.show",
                    sets: [],
                },
                {
                    name: "ticket-price-plans.create",
                    label: "Ticket Price Plans",
                    parent: "venues.show",
                    sets: [],
                },
                {
                    name: "venue-sales.index",
                    label: "Venue sales",
                    parent: "dashboard",
                    sets: ["sales"],
                },
                {
                    name: "event-sales.index",
                    label: "Event sales",
                    parent: "dashboard",
                    sets: ["sales"],
                },
                {
                    name: "revenue",
                    label: "Revenue",
                    parent: "dashboard",
                    sets: ["sales"],
                },
                {
                    name: "orders.index",
                    label: "Orders",
                    parent: "dashboard",
                    sets: ["sales"],
                },
                {
                    name: "orders.show",
                    label: "Order",
                    parent: "orders.index",
                    sets: [],
                },
                {
                    name: "checkin.show",
                    label: "Checkin",
                    parent: "checkin.index",
                    sets: [],
                },
                {
                    name: "checkin.manual",
                    label: "Checkin",
                    parent: "checkin.index",
                    sets: [],
                },
                {
                    name: "checkin.manual-with-ticket",
                    label: "Checkin",
                    parent: "checkin.index",
                    sets: [],
                },
                {
                    name: "events",
                    label: "Events",
                    parent: null,
                    sets: [],
                },
                {
                    name: "shop.event-group.show",
                    label: "Events",
                    parent: "events",
                    sets: [],
                },
                {
                    name: "event",
                    label: "Event",
                    parent: "events",
                    sets: [],
                },
                {
                    name: "checkout.show",
                    label: "Checkout",
                    parent: "event",
                    sets: [],
                },
                {
                    name: "checkout.success",
                    label: "Success",
                    parent: "events",
                    sets: [],
                },
                {
                    name: "ticket-plans.show",
                    label: "Update Ticket Plans",
                    parent: "ticket-plans.index",
                    sets: [],
                },
                {
                    name: "ticket-plans.create",
                    label: "Create Ticket Plans",
                    parent: "ticket-plans.index",
                    sets: [],
                },
                {
                    name: "ticket-plans.index",
                    label: "Ticket Plans",
                    parent: "dashboard",
                    sets: ["admin"],
                },
                {
                    name: "event-creation.create",
                    label: "Create events",
                    parent: "dashboard",
                    sets: ["admin"],
                },
                {
                    name: "invoices.index",
                    label: "Invoices",
                    parent: "dashboard",
                    sets: ["sales"],
                },
                // {
                //     name: "actions.show-add-seating-area-to-events",
                //     label: "Add seating area to events",
                //     parent: "dashboard",
                //     sets: ["actions"],
                // },
                {
                    name: "actions.show-cancel-events-and-transfer-orders",
                    label: "Cancel events and transfer orders to another event",
                    parent: "dashboard",
                    sets: ["actions"],
                },
                {
                    name: "actions.show-reschedule-event-and-notify-customers",
                    label: "Reschedule event and notify customers",
                    parent: "dashboard",
                    sets: ["actions"],
                },
                {
                    name: "actions.show-change-venue-for-events",
                    label: "Change venue for events and notify customers",
                    parent: "dashboard",
                    sets: ["actions"],
                },
            ],
        };
    },
    methods: {
        createLinksSet(set) {
            return this.links.filter((link) => link.sets.includes(set));
        },
    },
};
